import React, { useContext } from 'react';
import proptypes from 'prop-types';
import { AppContext } from '@thd-nucleus/app-render';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { Error } from './pages';
import { getRoutes } from './routes';

import './styles/app.scss';

const { elementType } = proptypes;

export const App = ({
  serverPages
}) => {
  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent, serverPages);
  const { channel } = useContext(ExperienceContext);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route exact path={routes.clearCallback.path} element={<routes.clearCallback.component />} />
        <Route exact path={routes.clearVerification.path} element={<routes.clearVerification.component />} />
        <Route exact path={routes.clearCallbackV2.path} element={<routes.clearCallbackV2.component />} />
        <Route exact path={routes.selfDropoff.path} element={<routes.selfDropoff.component />} />
        <Route exact path={routes.manageReservation.path} element={<routes.manageReservation.component />} />
        <Route exact path={routes.manageReservationV2.path} element={<routes.manageReservationV2.component />} />
        <Route exact path={routes.cancelReservation.path} element={<routes.cancelReservation.component />} />
        {/* TODO: Remove once transitioned off */}
        <Route exact path={routes.reservationDetails.path} element={<routes.reservationDetails.component />} />
        <Route exact path={routes.reservation.path} element={<routes.reservation.component />} />
        <Route exact path={routes.delivery.path} element={<routes.delivery.component />} />
        <Route exact path={routes.product.path} element={<routes.product.component />} />
        <Route exact path={routes.usedEquipment.path} element={<routes.usedEquipment.component />} />
        <Route path="/error" element={<Error />} />
        <Route element={<Error />} />
      </Routes>
    </>
  );
};

App.propTypes = {
  serverPages: proptypes.objectOf(elementType)
};

App.defaultProps = {
  serverPages: undefined
};